import { render, staticRenderFns } from "./createDuplicateFla.vue?vue&type=template&id=33f32a0a&"
import script from "./createDuplicateFla.vue?vue&type=script&lang=js&"
export * from "./createDuplicateFla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports